export default __webpack_public_path__ + "static/media/Youtube-gray.71b3f82c.svg";